<template>
  <hic-dialog append-to-body title="网页选择" :visible="visible" @close="cancel" top="6vh" width="50rem" :close-on-click-modal="false">
    <el-row type="flex" justify="space-between" align="middle">
      <el-button type="primary" @click="meta.showEditor = true" :disabled="meta.loading" size="small" icon="el-icon-plus">新建网页</el-button>
      <el-input v-model="keyword" size="small" class="condition-wide" placeholder="名称或编码" clearable></el-input>
    </el-row>
    <br />
    <el-table v-loading="meta.loading" ref="expandTable" :data="filtedItems">
      <el-table-column align="center" label="操作" width="120" key="iousCmd">
        <template #default="{ row }">
          <el-button type="primary" title="选择" size="mini" icon="el-icon-check" circle plain @click="selectPage(row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column align="left" label="名称" prop="name">
        <template #default="{ row }">
          <b>{{ row.name }}</b>
        </template>
      </el-table-column>
      <el-table-column align="left" label="编码" prop="code" />
      <el-table-column align="left" label="浏览权限" prop="name" width="240px">
        <template #default="{ row }">
          <div>{{ row.roles | roleName }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
    </div>
    <Editor v-model="entity" :visible.sync="meta.showEditor"></Editor>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      parent: Object,
      existed: Array,
    },
    components: {
      Editor: () => import("../page/edit"),
    },
    data() {
      return {
        meta: {
          loading: false,
          showEditor: false,
        },
        keyword: null,
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
      filtedItems() {
        return this.dict.WebPage.filter((p) => (!this.existed || !this.existed.length || this.existed.findIndex((e) => e.tgtCode == p.code) < 0) && (!this.keyword || p.code.includes(this.keyword) || p.name.includes(this.keyword)));
      },
    },
    filters: {
      roleName(val) {
        try {
          if (!val) return val;
          return JSON.parse(val)
            .map((el) => el.name)
            .join(",");
        } catch (error) {
          return val;
        }
      },
    },
    methods: {
      selectPage(row) {
        if (this.parent.tgtCode == row.code) {
          return;
        }

        let obj = {
          srcCode: this.parent.tgtCode,
          tgtCode: row.code,
        };
        this.meta.loading = true;
        api.SiteMap.query({ tgtCode: row.code }).then((res) => {
          if (res.items.length > 0) {
            this.meta.loading = false;
            return this.$message.warning("网站地图中已存在此页面，请勿重复添加！");
          }
          api.SiteMap.save(obj)
            .then((res) => {
              this.$message.success("添加成功!");
              this.$emit("close");
              this.cancel();
            })
            .catch((err) => {})
            .finally(() => {
              this.meta.loading = false;
            });
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
    },
  };
</script>
